import { useEffect } from "react";

type PageMeta = {
  title: string;
  description: string;
  jsonLd?: Record<string, unknown>[];
};

export function usePageMeta({ title, description, jsonLd = [] }: PageMeta) {
  const serialized = JSON.stringify(jsonLd);

  useEffect(() => {
    document.title = title;

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.page = "true";
    script.text = serialized;
    if (jsonLd.length) document.head.appendChild(script);

    return () => {
      script.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, serialized]);
}
